var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy337(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M65.8,13.3c-33.5,0,0,0-33.5,0c-4.3,0-9.5,8-8.7,19.7c0.8,12.3,11,22.4,23.8,23.2c14.8,0.9,27.1-10.4,27.1-24.4 C74.5,21.4,69.6,13.3,65.8,13.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_43_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 49.1,
    cy: 32.2,
    rx: 5.1,
    ry: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_41_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 58.7,
    cy: 22.7,
    rx: 2.7,
    ry: 2.7
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_40_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 39.4,
    cy: 22.7,
    rx: 2.7,
    ry: 2.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_39_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 35,
    cy: 72.8,
    rx: 9.3,
    ry: 9.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_38_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 63.1,
    cy: 72.8,
    rx: 9.3,
    ry: 9.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M64.3,88.3H33.8c-8.5,0-15.4-6.9-15.4-15.4v0c0-8.5,6.9-15.4,15.4-15.4h30.5c8.5,0,15.4,6.9,15.4,15.4v0 C79.7,81.4,72.8,88.3,64.3,88.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy337);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-337.ff9982f910a322093d0766d006762236.svg";
export { ForwardRef as ReactComponent };